import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { lazy, Suspense, useEffect } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { useAppDispatch } from "./utils/hooks";
import { loadSettings } from "./redux/slices/settingsSlice";
import { keys } from "./apis";
import Footer from "./components/Footer";
import { localeData } from "./data/locale";
// images
import footerLogo from "./images/equipments-footer-logo.png";
import Header from "./components/Header";
// pages
const SimpleLanding = lazy(() => import("./pages/SimpleLanding"));

const footerNav = [
  {
    path: "/contracting",
    name: localeData.cont,
  },
  {
    path: "/equipments",
    name: localeData.equipments,
    exact: true,
  },
  {
    path: "/transport",
    name: localeData.transport,
  },
  {
    path: "/",
    name: localeData.home,
  },
];

function Contracting() {
  const dispatch = useAppDispatch();

  // mount logic
  useEffect(() => {
    dispatch(loadSettings(keys.equip));
    document.title = localeData.equipments;
  }, []); // eslint-disable-line

  return (
    <>
      <Header siteKey={keys.equip} homePath="/equipments" />
      <Suspense
        fallback={
          <div className="text-center page-placeholder">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: "28px" }} />}
            />
          </div>
        }
      >
        <ErrorBoundary>
          <SimpleLanding siteKey={keys.equip} />
        </ErrorBoundary>
      </Suspense>
      <Footer siteKey={keys.equip} logo={footerLogo} navItems={footerNav} />
    </>
  );
}

export default Contracting;
